"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_1 = require("react");
const container_1 = require("./container");
const executor_1 = require("./executor");
const store_1 = require("./store");
exports.Provider = function (props) {
    const Context = store_1.getStoreContext(props.of);
    const containerRef = react_1.useRef();
    if (!containerRef.current) {
        containerRef.current = new container_1.Container();
    }
    const container = containerRef.current;
    const checkRef = react_1.useRef();
    function onChange(value) {
        if (props.storeRef) {
            if (typeof props.storeRef === 'function') {
                props.storeRef(value);
            }
            else {
                props.storeRef.current = value;
            }
        }
        checkRef.current.onInitialize();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(executor_1.Executor, { useStore: props.of, args: props.args, onChange: onChange, memo: props.memo, container: container }),
        React.createElement(Context.Provider, { value: container },
            React.createElement(Checker, { container: container, ref: checkRef }, props.children))));
};
exports.Provider.displayName = 'Provider';
exports.Provider.defaultProps = {
    args: [],
};
const Checker = react_1.forwardRef((props, ref) => {
    const [initialized, setInitialized] = react_1.useState(props.container.initialized);
    react_1.useImperativeHandle(ref, () => ({
        onInitialize: () => {
            setInitialized(true);
        }
    }));
    return initialized && (React.createElement(React.Fragment, null, props.children));
});
Checker.displayName = 'Checker';
